<template>
  <b-container style="place-items: center;">
      <b-col style="justify-content: center;" cols="12" sm="8" md="6" lg="5" xl="4" class="border-main-initial p-0">
        <b-row style="justify-self:center;" class="">
          <b-col md="12">
            <div style="place-self: center; font-size:32px" class="font-size-23px mb-3">
              <img src="../assets/img/vtrLogo.png" alt="Logo" style="margin: 12px; margin-bottom: 15px;" class="logo" />
              <br>
              <strong>Pago express</strong>
            </div>
          </b-col>
          <div class="width-full" v-if="!errorMS && !dueProcess">
            <ValidationProvider rules="rut" v-slot="{ errors }">
              <b-col md="12" class="mb-5">
                <p style="font-size: 16px;    padding: 5px; text-align: center;" class="mb-4">
                  ¡Paga tus <span style="color: #27A5BE;">boletas</span> vencidas o el total de tu deuda de forma <span
                    style="color: #27A5BE;">rápida</span> y <span style="color: #27A5BE;">fácil</span>!</p>

                <div style="padding-left: 2%;" class="input-group ">
                  <div><label for="rut" style="color: #747474;" class="form-label">Ingresa tu RUT</label>
                  </div>

                </div>
                <div style="width: 98%;padding-left: 2%;">
                  <b-form-input id="rut" class="input-default" type="text" name="rut" v-rut:live v-model="rut"
                    maxlength="12" placeholder="ej: 12.345.678-9" :state="errors[0] ? false : null">
                  </b-form-input>
                </div>
                <span class="has-error" v-if="errors[0]">El RUT es incorrecto.</span>

              </b-col>




              <b-col md="12" class="text-center mb-4">
                <b-button style="margin-bottom: 30px;width: 267px;" class="btn-continuar" variant="primary"
                  :disabled="rut == '' || (errors[0] ? true : false)" v-on:click="recaptcha">
                  <b>Pagar</b>
                </b-button>

                <b-col md="12" class="mb-5">
                  <p class="font-size-13px mb-4">
                    Para ver tu boleta ingresa a la <a href="https://apps.vtr.com" target="_blank">sucursal virtual </a>
                    <strong>seccion boleta.</strong>
                  </p>
                </b-col>
              </b-col>
            </ValidationProvider>
          </div>
          <div class="width-full" v-if="errorMS && !dueProcess">
            <b-col md="12">
              <p style="margin: 20px;place-self: center;width: 226px;" class="font-size-13px mb-5">
                En este momento el servicio no está disponible. Por favor
                intenta más tarde.
              </p>
            </b-col>
            <b-col md="12" style="width: 267px;justify-self: center;
" class="text-center mb-4">
              <b-button class="btn-continuar" variant="primary" v-on:click="goToVtr">
                <b>Volver a VTR</b>
              </b-button>
            </b-col>
          </div>
          <div class="width-full" v-if="dueProcess && !errorMS">
            <b-col md="12">
              <p style="text-align: center;" class="font-size-13px mb-3">
                Actualmente tienes un pago en proceso. Favor, intenta pagar
                nuevamente en las próximas horas. Para más detalle ingresa a tu
                <a href="https://apps.vtr.com/index.html">Sucursal Virtual</a>.
              </p>
            </b-col>
            <b-col md="12" class="text-center mb-4">
              <b-button     width: 267px !important;justify-self: center;
              class="btn-continuar" variant="primary" v-on:click="goToVtr">
                <b>Volver a VTR</b>
              </b-button>
            </b-col>
          </div>
        </b-row>
      </b-col>
    <b-row class="text-center mb-5">
      <b-col md="12">
        <div style="margin-top: 25px;">
          <img src="../assets/img/logoRecapt.png" />
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import config from "@/config";
import Vue from "vue";
import { rutValidator, rutInputDirective } from "vue-dni";
import { extend } from "vee-validate";
import { VueReCaptcha } from "vue-recaptcha-v3";
import axios from "axios";
import wait from "@/wait";
Vue.use(VueReCaptcha, { siteKey: constants.recaptcha.siteKey });
import * as rutHelpers from "rut-helpers";
import * as constants from "@/common/constants";

import { log } from "@/logging";

window.bus = new Vue({});
Vue.directive("rut", rutInputDirective);
extend("rut", rutValidator);

export default {

  data() {
    return {
      rut: "",
      publicPath: "",
      dueProcess: false,
      errorMS: false, viewModalC: false
    };
  },
  computed: {
    pid() {
      return this.$route.params.pid;
    },
  },
  methods: {
    error: function (method, error) {
      log.error("Error trying to " + "[" + method + "] " + error);
      this.errorMS = true;
      wait.end("loading.everything");
      window.digitalData = {};

      window.dataLayer.push({ event: "cargaErrorPago" });
    },



    initRut: function () {
      let rutSimple = rutHelpers.rutClean(this.rut);
      rutSimple =
        rutSimple.slice(0, rutSimple.length - 1) +
        "-" +
        rutSimple.substr(rutSimple.length - 1);
      return rutSimple;
    },
    goToVtr: function () {
      window.open(constants.redirect.production.vtr_com.normal, "_self");
    },
    async recaptcha() {
      wait.start("loading.everything");
      await this.$recaptchaLoaded();
      const tokenRecaptcha = await this.$recaptcha("billingAccount");
      this.getOauthToken(tokenRecaptcha, this.initRut());
    },
    async getOauthToken(tokenRecaptcha, rut) {
      try {
        const response = await axios.get(config.endpoints.oauthToken);
        if (
          response.status === 200 &&
          response.data.statusCode === 200 &&
          response.data.body !== undefined
        ) {
          log.info("getOauthToken true!");
          const tokenOauth = response.data.body;
          this.$store.getters.tokenOauth = tokenOauth;
          this.getCurtain(
            tokenRecaptcha,
            this.$store.getters.tokenOauth,
            this.initRut()
          );
        } else {
          this.error("getOauthToken", "");
        }
      } catch (e) {
        this.error("getOauthToken", e);
      }
    },
    async getCurtain(tokenRecaptcha, tokenOauth, rut) {
      const params = {
        canal: "PP",
        rut: rut,
      };
      const headers = {
        Authorization: "Bearer " + tokenOauth,
      };
      try {
        const response = await axios.get(
          config.endpoints.curtain +
          "?rut=" +
          params.rut +
          "&canal=" +
          params.canal,
          { headers }
        );
        if (
          response.status === 200 &&
          response.data.status === 200 &&
          response.data.data !== undefined
        ) {
          log.info("getCurtain " + response.data.data[0].activa);
          this.curtainActive = response.data.data[0].activa;
          this.$store.dispatch("createCurtainActive", {
            activa: response.data.data[0].activa,
            txtError: this.getDecoded(response.data.data[0].txtError),
            tituloMigrado: this.getDecoded(response.data.data[0].tituloMigrado),
            txtMigrado: this.getDecoded(response.data.data[0].txtMigrado),
            tituloNoMigrado: this.getDecoded(
              response.data.data[0].tituloNoMigrado
            ),
            txtNoMigrado: this.getDecoded(response.data.data[0].txtNoMigrado),
          });
          if (this.$store.getters.curtain.activa) {
            this.$router.push({
              path: "/curtain",
            });
            console.debug("Router pushed!");
          } else {
            this.getSessionId(tokenRecaptcha, tokenOauth, rut);
          }
        } else {
          this.error("getCurtain", "");
        }
      } catch (e) {
        this.error("getCurtain", e);
      }
      return;
    },
    getDecoded(str) {
      var enc = encodeURI(str);
      var dec = decodeURI(enc);
      return dec;
    },
    goToStart() {
      //Ir al paso 1
      if (this.pid) {
        this.$router.push({
          path: "/start/" + this.pid,
        });
      } else {
        this.$router.push({
          path: "/start/",
        });
      }
    },
    async getPaymentStatus(sessionId, tokenOauth, rut) {
      const headers = {
        Authorization: "Bearer " + tokenOauth,
        //sessionId: sessionId
      };
      try {
        const response = await axios.get(
          config.endpoints.paymentStatus +
          "?customerIdentificationNumber=" +
          rut,
          { headers }
        );

        if (response.status === 200 && response.data.status.success === true) {
          log.info("getStatusPayment true!");
          if (response.data.billingAccountIds) {
            if (response.data.billingAccountIds.length > 0) {
              this.dueProcess = true;
            } else {
              if (this.$store.getters.curtain.activa) {
                this.$router.push({
                  path: "/curtain",
                });
                console.debug("Router pushed!");
              } else {
                this.goToStart();
              }
            }
          } else {
            if (this.$store.getters.curtain.activa) {
              this.$router.push({
                path: "/curtain",
              });
              console.debug("Router pushed!");
            } else {
              this.goToStart();
            }
          }
          wait.end("loading.everything");
        } else {
          this.error("getStatusPayment", "");
        }
      } catch (e) {
        this.error("getStatusPayment", e);
      }
    },
    async getSessionId(tokenRecaptcha, tokenOauth, rut) {
      const params = {
        token: tokenRecaptcha,
        rut: rut,
        formulario: constants.recaptcha.formulario,
      };
      const headers = {
        Authorization: "Bearer " + tokenOauth,
      };
      try {
        const response = await axios.post(config.endpoints.session, params, {
          headers,
        });
        if (
          response.status === 200 &&
          response.data.status === 200 &&
          response.data.data !== undefined
        ) {
          log.info("getSessionId true!");

          //Guardar sessionId y tokenOauth
          this.$store.getters.sessionId = response.data.data.sessionId;
          this.$store.getters.tokenOauth = tokenOauth;
          this.$store.dispatch("resetBillingState");

          //Ocultar Badge de recaptcha
          const recaptcha = this.$recaptchaInstance;
          recaptcha.hideBadge();

          //Marcar interaccion
          this.$store.dispatch("insertSuccessInitialInteraction", { rut: rut });

          //Verificar si hay algun pago en proceso
          this.getPaymentStatus(response.data.data.sessionId, tokenOauth, rut);
        } else {
          this.error("getSessionId", "");
        }
      } catch (e) {
        this.error("getSessionId", e);
      }
    },
  },
  created() {
    this.publicPath = config.url.base;
    this.$store.dispatch("resetBillingState");
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: "vpv" });
  },
};
</script>

<style lang="scss">
@import "@/style/main.scss";

.border-main-initial {
  border: 1px solid #D8D8D8;
  border-radius: 12px;
  backdrop-filter: blur(2px);
  box-shadow: 0px 4px 4px 0px #00000040;
}






.btn-continuar {
  height: 40px;
  width: 100%;
}

.cont-webpay-servipag {
  background: #f4f5f9;
  border-top: 1px solid #e7e6e7;
  padding: 16px 10px;
}

.cont-row-main {
  margin-bottom: 20px;
}

.img-icon-peso {
  margin-right: 3px;
  padding-bottom: 4px;
}
</style>
